<template>
  <div class="d-flex justify-content-center">
    <b-row class="mt-5 col-12 col-lg-12 col-xl-12">
      <b-col class="col-12 text-center">
        <h1 class="mb-1">{{ $t('creator.compensationTitle') }}</h1>
        <p>{{ $t('creator.compensationText') }}</p>

        <b-button-group class="w-100 mt-1 mb-2">
          <b-button 
            @click="tabs_options = 0" 
            :class="{'active': tabs_options === 0}" 
            class="button-tabs-options mr-1" 
            variant="button-tabs-options"
            
          >
            {{$t('creator.negotiableOnly')}}
          </b-button>
          <b-button 
            @click="tabs_options = 1" 
            :class="{'active': tabs_options === 1}" 
            class="button-tabs-options" 
            variant="button-tabs-options"
          >{{$t('creator.fixedOnly')}}</b-button>
        </b-button-group> 
        <div v-if="tabs_options === 0">
          <p>
            {{$t('creator.compensationLastText')}}
          </p>
        </div>

        <div v-if="tabs_options === 1">
          <strong class="text-danger col-12 mt-2 h4 d-block" v-if="show_asset_type_error">{{ $t('creator.amount0') }}</strong>
          <div class="position-relative">
  
            <b-dropdown class="w-100 mt-2" menu-class="w-100" variant="outline-secondary" :disabled="compensations.length > 4">
              <template #button-content>
                {{ $t('creator.addCompensation') }}
              </template>
              <b-dropdown-item v-for="(item) in compensations_availble" :key="item.value" @click="addCompensationType(item)">
                <div @mouseover="hovered_item = item" @mouseout="hovered_item = null">
                  <div class="d-flex align-items-center">
                    <b-icon v-if="getCompensation(item.value).icon && item !== selected_compensation"
                            :icon="getCompensation(item.value).icon"
                            class="mr-05"></b-icon>
                    <b-img v-else class="icon-svg mr-05"
                          :src="getImageSource(item)"></b-img>
                    <div>
                      <strong>{{item.text}}</strong>
                      <p class="avenir-medium m-0 text-description">{{item.description}}</p>
                    </div>
                  </div>
                </div>
              </b-dropdown-item>
            </b-dropdown>
            <div v-for="compensation in compensations" :key="compensation.value" class="d-flex justify-content-between">
              <div class="d-flex align-items-center py-2">
                <b-icon v-if="getCompensation(compensation.value).icon" :icon="getCompensation(compensation.value).icon" class="mr-05"></b-icon>
                  <b-img v-else class="icon-svg mr-05" :src="IconTypeCompetation(compensation.value)"></b-img>
                <strong>{{compensation.text2}}</strong>
              </div>
              <div class="d-flex align-items-center">
                <div>
                  <b-input-group @keyup.enter="compensation.amount.length > 0 ? save(): ''">
                    <b-input-group-prepend is-text>
                      <feather-icon
                        icon="DollarSignIcon"
                        class="text-muted"
                      />
                    </b-input-group-prepend>
                    <cleave
                      v-model="compensation.amount"
                      :options="options_number"
                      class="form-control"
                      @input="isValidCompensations"
                      :raw="false"
                    />
                  </b-input-group>
                </div>
                <b-button variant="flat-secondary" class="flat-secondary-delete-links" @click="deleteFromList(compensation)">
                  <feather-icon icon="TrashIcon"></feather-icon>
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <b-col class="col-12 d-flex justify-content-center">
          <b-button variant="blue-button-next-step" class="blue-button-next-step my-2" :disabled="tabs_options === 1 && (!is_valid || invalid_networks)"  @click="save()">{{has_slug ? $t('creator.savePreview') : $t('creator.butonNext')}}</b-button>
        </b-col>
      </b-col>
      <small class="mt-2 w-100 text-center text-muted" v-if="tabs_options === 1">{{ $t('creator.compensationRequired') }}</small>
    </b-row>
    <modal-brandme
  size="md"
  v-if="modal_confirmation"
  :show_modal="modal_confirmation"
  @hidden="closeModalConfirmation"
>
  <template #title>
    {{ $t('creator.confirmAction') }}
  </template>

  <template #body>
  <div>
    {{ $t('creator.sureDeleteCompentation') }}
  </div>

  <div
    v-if="compensation_to_delete"
    class="mt-3 p-2 border rounded bg-light"
  >
      <b-icon v-if="getCompensation(compensation_to_delete.value).icon" :icon="getCompensation(compensation_to_delete.value).icon" class="mr-05"></b-icon>
      <b-img v-else class="icon-svg mr-05" :src="IconTypeCompetation(compensation_to_delete.value)"></b-img>
      <strong>{{compensation_to_delete.text2}}</strong>
      <small class="text-muted" v-if="compensation_to_delete.amount">
      $ {{ separatebycomma(compensation_to_delete.amount) }}  USD
    </small>


  </div>

  <div class="d-flex justify-content-end mt-2">
    <b-button
      variant="outline-secondary mr-2"
      @click="closeModalConfirmation"
    >
     {{ $t('creator.cancel') }}
    </b-button>

    <b-button
      variant="danger"
      @click="confirmDeleteCompensation"
    >
      {{ $t('creator.delete') }}
    </b-button>
  </div>
</template>
</modal-brandme>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BDropdown,
  BDropdownItem,
  BInputGroup,
  BInputGroupPrepend,
  BImg,
  BIcon,
  BButtonGroup,
} from 'bootstrap-vue';
import utils from '@/libs/utils';
import casting_calls_services from '@/services/casting_calls';
import Cleave from 'vue-cleave-component';
import { IconTypeCompetation, IconTypeCompetationPrimary } from '@/libs/utils/icons';
import { separatebycomma } from '@/libs/utils/formats'

export default {
  name: 'stepCompensation',
  components: {
    BIcon,
    BImg,
    BRow,
    BCol,
    BButton,
    BDropdown,
    BDropdownItem,
    BInputGroup,
    BInputGroupPrepend,
    BButtonGroup,
    Cleave,
    modalBrandme: () => import('@/views/components/modal/ModalBrandme.vue'),
  },
  props: {
    invalid_networks: {
      type: Boolean,
      default: false
    },
    networks_selected: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      separatebycomma,
      modal_confirmation: false,
      compensation_to_delete: null,
      is_valid: false,
      tabs_options: 0,
      selected_compensation: null,
      hovered_item: null,
      IconTypeCompetationPrimary,
      IconTypeCompetation,
      compensations: [],
      compensations_availble: this.$t('creator.compensation_type'),
      profile: {},
      utils,
      steps: null,
      casting_call: {},
      casting_call_uuid: '',
      show_dropdown: false,
      tag: '',
      show_asset_type_error: false,
      options_number: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand'
      },
    }
  },
  created() {
    this.getData();
    if (this.compensations.length === 0) {
      this.addCompensationType(this.$t('creator.compensation_type')[0]);
    }

  },
  computed: {
    has_slug() {
      return this.$route.params.slug
    }
  },
  methods: {
    isValidCompensations() {
      this.is_valid = this.compensations.every(compensation => {
        return compensation.amount && compensation.amount.length > 0 && parseFloat(compensation.amount) > 0;
      });
    },
    getImageSource(item) {
      if (item === this.selected_compensation) {
        return IconTypeCompetation(item.value);
      } else if (item === this.hovered_item) {
        return IconTypeCompetationPrimary(item.value);
      } else {
        return IconTypeCompetation(item.value);
      }
    },
    getCompensation(compensation_value) {
      return this.$t('creator.compensation_type').find((c) => c.value === compensation_value)
    },
    deleteFromList(compensation) {
      this.compensation_to_delete = compensation
      this.modal_confirmation = true
    },

    closeModalConfirmation() {
      this.modal_confirmation = false
      this.compensation_to_delete = null
    },

    confirmDeleteCompensation() {
      const compensation = this.compensation_to_delete

      if (!compensation) return

      const is_last_compensation = this.compensations.length === 1

      if (compensation.uuid) {
        casting_calls_services.deleteCompensation(this.casting_call_uuid,compensation.uuid)

        if (is_last_compensation) {
          const payload = {
            type_compensation: 'negotiable',
            work_types: this.selected_networks || []
          }

          casting_calls_services.updateCastingCall(
            this.casting_call_uuid,
            payload
          )

          this.tabs_options = 0
        }
      }

      this.compensations = this.compensations.filter((f) => f.value !== compensation.value)

      this.compensations_availble.push(this.$t('creator.compensation_type').find((item) => item.value === compensation.value))

      this.closeModalConfirmation()
    },
    getCompensationFormatData() {
      this.casting_call.compensations.forEach((compensation) => {
        this.compensations.push({
          amount: parseInt(compensation.amount),
          ...this.$t('creator.compensation_type').find((item) => item.value === compensation.type_compensation),
          uuid: compensation.uuid
        });
        this.compensations_availble = this.compensations_availble.filter((item) => item.value !== compensation.type_compensation)
      });
    },
    addCompensationType(compensation) {
      compensation['amount'] = null;
      this.compensations.push(compensation)
      this.compensations_availble = this.compensations_availble.filter((item) => item.value !== compensation.value)
    },
    getData() {
      if (this.has_slug) {
        this.casting_call = this.$route.params.casting_call_data;
        this.casting_call_uuid = this.casting_call.uuid;
        if (this.casting_call.type_compensation === 'negotiable') {
          this.tabs_options = 0
        } else {
          this.tabs_options = 1;
          this.getCompensationFormatData();
        }
      } else {
        this.steps = JSON.parse(localStorage.getItem('steps'));
        this.tabs_options = this.steps?.type_compensation === 'fixed' ? 1 : 0;
        this.casting_call.compensations = this.steps?.compensations || [];
        this.getCompensationFormatData();
      }
    },
    hasValueCompensations() {
      let counter = 0;
      this.compensations.forEach((compensation) => {
        if (compensation.amount !== null && compensation.amount !== 0) counter += 1;
      })
      counter !== this.compensations.length ? this.show_asset_type_error = true : this.show_asset_type_error = false
      return counter === this.compensations.length
    },
    setSteps() {
      this.steps['type_compensation'] = this.tabs_options === 0 ? 'negotiable' : 'fixed';
      this.steps['work_types'] = this.networks_selected;

      if (this.hasValueCompensations() && this.tabs_options === 1) {
        const compensations = this.compensations.map((item) => {
          return {
            type_compensation: item.value,
            amount: parseInt(item.amount.split(',').join('')),
          }
        });
        this.steps['compensations'] = compensations;
      } else {
        this.steps['compensations'] = []
      }

      localStorage.setItem('steps', JSON.stringify(this.steps));
    },
    save() {
      if (this.has_slug) {
        const form_data = {
          type_compensation: this.tabs_options === 0 ? 'negotiable' : 'fixed',
          work_types: this.networks_selected,
        }

        casting_calls_services.updateCastingCall(this.casting_call_uuid, form_data).then((response) => {
          if (this.tabs_options === 0) {
            localStorage.removeItem('steps');
            this.$root.$emit('quit_navbar_white');
            this.$router.push({name: 'view_casting_call', params: {slug: this.$route.params.slug}})
          } else {
            this.casting_call = response.response
            const formated_data = this.compensations.map((item) => {
              return {
                type_compensation: item.value,
                amount: parseInt(item.amount.split(',').join('')),
                uuid: item.uuid,
              }
            });
            const compensation_to_update = formated_data.filter((compensation_filter) => compensation_filter.uuid);
            const compensation_to_create = formated_data.filter((compensation_filter) => !compensation_filter.uuid);
            casting_calls_services.attatchCompensations(this.casting_call_uuid, {compensations: compensation_to_create}).then(() => {
              casting_calls_services.updateCompensations(this.casting_call_uuid, {compensations: compensation_to_update}).then(() => {
                localStorage.removeItem('steps');
                this.$root.$emit('quit_navbar_white');
                this.$router.push({name: 'view_casting_call', params: {slug: this.$route.params.slug}})
              })
            })
          }
        })
      } else {
        this.setSteps();
        this.$router.push({ name: 'steps_casting_call', params: {step: 'location'} });
      }
    },
  }
}
</script>
<style>
.icon-svg {
  width: 18px;
}
.text-description {
  white-space: break-spaces;
}
.dropdown-add-tags .btn {
  width:  100% !important;
  padding: 0 !important;
}
</style>
<style scoped lang="scss">
.button-tabs-options {
  background: #e9ecef !important;
  border-radius: 0.7em !important;
  padding: 1.5em !important;

  &:hover  {
    background: #dee2e6 !important;

    &:disabled {
      background: #e9ecef !important;
    }
  }

  &.active {
    background-color: #54575a !important;
    color: white !important
  }
}
.flat-secondary-delete-links {
  padding: 0.5em !important;
  height: 35px !important;
  margin-left: 1em;
}
.mr-05 {
  margin-right: 0.5em;
}
</style>